// extracted by mini-css-extract-plugin
export default {"button":"styles_button__nBed6","isActive":"styles_isActive__aagL2"};